<template>
    <div>
        <div v-if="mode==='pc'">
            <pc-server></pc-server>
        </div>
        <div v-if="mode==='mobile'">
            <mobile-server></mobile-server>
        </div>
    </div>
</template>

<script>
    import PcServer from '@/components/pc/PCServer'
    import MobileServer from '@/components/mobile/mobileServer'
    export default {
        components:{
            PcServer,
            MobileServer
        },
        computed:{
            mode(){
                return this.$store.state.mode;
            }
        },
        mounted(){
            var me = this;
            if (!me.$store.state.ifLogin) {
                me.$router.push({ path: "/" });
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/pages/server.vue